import { Button } from "@/components/common/Button";
import Skeleton from "@/components/common/Skeleton";
import { useUserStore } from "@/modules/auth/store/user";
import { formatNumber } from "@/modules/auth/utils/format";
import { AnalyticsEvents } from "@/shared/utils/analytics/events";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";

const Statistics = () => {
  const { t } = useTranslation();
  const { network, isNetworkLoading } = useUserStore();

  const navigate = useNavigate();

  const levels = network?.levels || [];

  const goToDetailed = () => {
    navigate("/network/detailed");
  };

  return (
    <div className="flex w-full flex-col">
      <p className="p-4 pb-2 text-[0.8125rem] leading-[1rem] text-section-header-text tracking-tighter uppercase">
        {t("network-page.team_statistics")}
      </p>
      <div className="w-full flex flex-col gap-4 px-4 py-3 bg-bg rounded-[0.75rem]">
        <div className="flex items-center justify-between gap-4">
          <div className="flex items-center gap-4">
            <div className="flex flex-col gap-0.5">
              {isNetworkLoading ? (
                <Skeleton className="w-10 h-7" />
              ) : (
                <p className="text-[1.5rem] leading-[1.75rem] font-semibold text-text">
                  {network?.referralsVolume.referralsNumber || 0}
                </p>
              )}
              <p className="text-[0.9375rem] leading-[1.25rem] text-subtitle-text">
                {t("network-page.referrals")}
              </p>
            </div>
          </div>

          <div className="flex flex-col items-end gap-0.5">
            {isNetworkLoading ? (
              <Skeleton className="w-10 h-7" />
            ) : (
              <p className="text-[1.5rem] leading-[1.75rem] font-semibold text-text">
                ${formatNumber(network?.teamVolume.usdt || 0)}
              </p>
            )}
            <p className="text-[0.9375rem] leading-[1.25rem] text-subtitle-text">
              {t("network-page.team_turnover")}
            </p>
          </div>
        </div>

        <div className="flex items-center justify-left gap-4">
          <div className="flex items-center gap-4">
            <div className="flex flex-col gap-0.5">
              {isNetworkLoading ? (
                <Skeleton className="w-10 h-7" />
              ) : (
                <p className="text-[1.5rem] leading-[1.75rem] font-semibold text-text">
                  {network?.referralsVolume.allReferralsNumber || 0}
                </p>
              )}
              <p className="text-[0.9375rem] leading-[1.25rem] text-subtitle-text">
                {t("network-page.all_referrals")}
              </p>
            </div>
          </div>
        </div>

        {levels[0] && levels[0].allReferralsNumber > 0 && (
          <Button
            onClick={goToDetailed}
            text={t("network-page.detailed")}
            mode="bezeled"
            className="w-full"
            disabled={isNetworkLoading}
            analyticsEvent={AnalyticsEvents.Network.ViewDetailed}
          />
        )}
      </div>
    </div>
  );
};

export default Statistics;
